import { Capacitor } from '@capacitor/core';

/**
 * Runtime check for native (iOS/Android) vs web.
 * Wraps Capacitor.isNativePlatform() so callers don't have to import
 * Capacitor everywhere and so we can mock it cleanly in tests.
 */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * Returns the runtime platform, narrowed to a known set.
 * Anything Capacitor doesn't recognize as 'ios' or 'android' falls back
 * to 'web' so downstream consumers can use exhaustive switches without
 * `as` casts.
 */
export function getPlatform(): 'ios' | 'android' | 'web' {
  const p = Capacitor.getPlatform();
  return p === 'ios' || p === 'android' ? p : 'web';
}
